import { defineMessages } from "react-intl";
const messages = defineMessages({
    spaceFloorplanUploadTitle: {
        id: "app.space.details.floorPlanTitle.text",
        defaultMessage: "Floorplan",
    },
    updateSpaceFloorplanSuccess: {
        id: "app.space.details.floorplan.update.success.text",
        defaultMessage: "Floorplan updated successfully.",
    },
});
export default messages;
